import { FC } from "react";
import { Savings } from "@mui/icons-material";

import { useMetamask, useWriteContractWithSimulation } from "@dzambalaorg/react-hooks-eth";
import { getEthPrice } from "@framework/exchange";
import { ListAction, ListActionVariant } from "@framework/styled";
import { AddressType, type IPonziRule, PonziRuleStatus } from "@framework/types";
import PonziDepositABI from "@framework/abis/json/Ponzi/deposit.json";
import { ZeroAddress } from "@framework/constants";

export interface IPonziDepositButtonProps {
  className?: string;
  disabled?: boolean;
  rule: IPonziRule;
  variant?: ListActionVariant;
}

export const PonziDepositButton: FC<IPonziDepositButtonProps> = props => {
  const { className, disabled, rule, variant } = props;

  const { writeContractAsync } = useWriteContractWithSimulation();

  const referrer = ZeroAddress;

  const { execute: metaDeposit } = useMetamask(async (rule: IPonziRule) => {
    // TODO pass real tokenId of selected ERC721 or ERC998
    // const tokenId = 0;
    // const tokenId = rule.deposit!.components[0].templateId; // for 1155

    // TODO check ponzi contract referral feature?
    return writeContractAsync({
      address: rule.contract.address as AddressType,
      abi: PonziDepositABI,
      functionName: "deposit",
      args: [
        referrer,
        rule.externalId,
        {
          value: getEthPrice(rule.deposit),
        },
      ],
    });
  });

  const handleDeposit = (rule: IPonziRule): (() => Promise<void>) => {
    return (): Promise<void> => {
      return metaDeposit(rule).then(() => {
        // TODO reload page
      });
    };
  };

  if (rule.ponziRuleStatus !== PonziRuleStatus.ACTIVE) {
    return null;
  }

  return (
    <ListAction
      onClick={handleDeposit(rule)}
      icon={Savings}
      message="form.tips.deposit"
      className={className}
      dataTestId="StakeDepositSimpleButton"
      disabled={disabled}
      variant={variant}
    />
  );
};
